import { MULTIPLE_USER_POWER_AGREEMENT } from '../../../../../../../constants';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  RulesetResult,
  IsSystemPowerCommunityOrPPALeaseEqualTo,
  IsSystemPowerSingleOrMultipleUsersEqualTo,
  IsApplicationSolar,
} from '../rules';

class CommunitySolarFinancialProjectionsRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    if (!IsApplicationSolar.evaluate(data)) return RulesetResult.HIDDEN;
    const isMultipleUsers =
      IsSystemPowerSingleOrMultipleUsersEqualTo.setValue(
        'Multiple Users'
      ).evaluate(data);
    const isCommunitySolar = IsSystemPowerCommunityOrPPALeaseEqualTo.setValue(
      MULTIPLE_USER_POWER_AGREEMENT.COMMUNITY_SOLAR
    ).evaluate(data);

    if (isMultipleUsers && isCommunitySolar) return RulesetResult.REQUIRED;
    return RulesetResult.HIDDEN;
  };
}
export default new CommunitySolarFinancialProjectionsRuleset();
